<template>
  <v-dialog v-model="dialog" max-width="700px" transition="dialog-transition">
    <template v-slot:activator="{ attrs }">
      <!-- v-on="on" -->
      <v-btn
        small
        color="success"
        v-bind="attrs"
        :loading="isloading"
        @click="OpenBalanceDialog"
        icon
      >
        <v-icon>fas fa-ellipsis-v</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline justify-center"
        >{{ `${supp.CostName}` }}
        <v-spacer></v-spacer>
        <v-btn text icon color="primary" @click="dialog = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="font-weight-black title text-center">
        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="QaasList"
              hide-default-footer
              class="elevation-1"
              pagination.sync="pagination"
              item-key="_id"
              :loading="isloading"
            >
              <template v-slot:top>
                <v-toolbar class="elevation-0" color="grey lighten-3">
                  <v-toolbar-title>
                    Qaas List
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <AddToQaas :supp="supp" :onFinish="OpenBalanceDialog" />
                  </v-toolbar-items>
                </v-toolbar>
              </template>
              <template v-slot:[`item.remove`]="{ item }">
                <base-delete
                  :DelUrl="ReqURL"
                  :DelQuery="{ qaas: item.AccountNumber, supp: supp._id }"
                  :OnFinish="OpenBalanceDialog"
                >
                  <h3>Are you Sure to Delete: {{ item.FullName }}</h3>
                </base-delete>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {
    AddToQaas: () => import("./AddQaas"),
  },
  props: {
    supp: { type: Object, required: true },
  },
  data() {
    return {
      ReqURL: "/supplier/qaas",
      dialog: false,
      isloading: false,
      QaasList: [],
      headers: [
        {
          text: "ID",
          value: "AccountNumber",
        },
        {
          text: "Name",
          value: "FullName",
        },
        {
          text: "Remove",
          value: "remove",
        },
      ],
    };
  },
  methods: {
    OpenBalanceDialog(scape = false) {
      // console.log(ID);
      if (this.QaasList.length && !scape) {
        this.dialog = true;
        return;
      }
      this.isloading = true;
      this.$store
        .dispatch("FIND_BY_VALUE", {
          url: this.ReqURL,
          query: { _id: this.supp._id },
        })
        .then(result => {
          this.dialog = true;
          this.isloading = false;
          this.QaasList = result.data;
        })
        .catch(() => {
          // console.log(error);
          //   this.clickedID = "";
          this.isloading = false;
        });
    },
  },
};
</script>
